export const ERROR_API_UNCOMPATIBLE_PAYLOAD = new Error('Payload is not compatible')
